import React from 'react';
import { motion } from 'framer-motion';
import { Users, BookOpen, HeartHandshake } from 'lucide-react';
export function Community() {
  return <section id="community" className="py-24 bg-hope-cream" data-id="element-26">
      <div className="max-w-7xl mx-auto px-6" data-id="element-27">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-28">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-serif font-bold text-hope-brown mb-6" data-id="element-29">
            Centro Comunitario <br data-id="element-30" />
            <span className="text-hope-olive" data-id="element-31">Palabras de Esperanza</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-hope-brown/80 leading-relaxed" data-id="element-32">
            HOPE Cafetería is the welcoming front door to our community center.
            Our mission is to empower the people of Puerto Peñasco through
            our different programs like medical care, food insecurity, youth groups, 
            empowering women, and more.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-33">
          {[{
          icon: Users,
          title: 'Youth & Families',
          desc: 'Providing safe spaces, mentorship, and activities for local children and families.'
        }, {
          icon: BookOpen,
          title: 'Education',
          desc: 'Offering music classes and resources to help individuals build a better future.'
        }, {
          icon: HeartHandshake,
          title: 'Outreach',
          desc: 'Meeting practical needs in our neighborhood through food provision, health support.'
        }].map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2 + idx * 0.1
        }} className="bg-white p-8 rounded-3xl shadow-soft text-center" data-id="element-34">
              <div className="w-16 h-16 mx-auto bg-hope-olive/10 rounded-2xl flex items-center justify-center mb-6 text-hope-olive" data-id="element-35">
                <item.icon size={32} data-id="element-36" />
              </div>
              <h3 className="text-xl font-serif font-bold text-hope-brown mb-3" data-id="element-37">
                {item.title}
              </h3>
              <p className="text-hope-brown/70" data-id="element-38">{item.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative rounded-3xl overflow-hidden shadow-2xl" data-id="element-39">
          <div className="aspect-[21/9] md:aspect-[21/7]" data-id="element-40">
            <img src="https://cdn.magicpatterns.com/uploads/mS4wwcSa46LJrkvKxBf1fs/IMG_9575.jpg" alt="Community Center" className="w-full h-full object-cover" data-id="element-41" />
            <div className="absolute inset-0 bg-gradient-to-t from-hope-brown/90 via-hope-brown/40 to-transparent flex flex-col justify-end p-8 md:p-12" data-id="element-42">
              <h3 className="text-3xl font-serif font-bold text-white mb-4" data-id="element-43">
                Join Our Mission
              </h3>
              <p className="text-white/90 max-w-2xl mb-6 text-lg" data-id="element-44">
                Whether you buy a coffee, volunteer your time, or make a
                donation, you are making a difference in Puerto Peñasco.
              </p>
              <div data-id="element-45">
                <a href="https://www.penascowordsofhope.org/" target="_blank" rel="noopener noreferrer" className="inline-block px-8 py-4 bg-hope-mustard text-hope-brown rounded-full font-bold hover:bg-hope-mustard/90 transition-colors shadow-lg" data-id="element-46">
                  Learn how to support
                </a>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}